import { type MutableRefObject, useCallback, useRef } from 'react'
import type { ShapeManagerRef } from '@/lib/shapes/types/shape-manager-ref'

/**
 * The canvas's own handle on its ShapeManager, and the callback ref that fills it and mirrors it
 * into the parent's `shapeManagerRef`.
 */
export function useShapeManagerRef({
  shapeManagerRef,
}: {
  shapeManagerRef: MutableRefObject<ShapeManagerRef | null> | undefined
}) {
  const internalShapeManagerRef = useRef<ShapeManagerRef | null>(null)
  const setShapeManagerRef = useCallback(
    (instance: ShapeManagerRef | null) => {
      internalShapeManagerRef.current = instance
      if (shapeManagerRef) {
        shapeManagerRef.current = instance
      }
    },
    [shapeManagerRef]
  )

  return { internalShapeManagerRef, setShapeManagerRef }
}
